import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'app-iframe-modal',
    standalone: true,
    imports: [CommonModule, MatIconModule, MatButtonModule],
    template: `
        <div class="iframe-modal">
            <button mat-icon-button class="close-button" (click)="closeModal()">
                <mat-icon>close</mat-icon>
            </button>
            <iframe
                [src]="data.iframeUrl"
                width="100%"
                height="100%"
                frameborder="0"
                style="border: none;">
            </iframe>
        </div>
    `,
    styles: [`
        .iframe-modal {
            position: relative;
            width: 100%;
            height: 100%;
        }
        .close-button {
            position: absolute;
            top: -5px;
            right: -5px;
            z-index: 1000;
        }
    `]
})
export class IframeModalComponent {
    constructor(
        @Inject(MAT_DIALOG_DATA) public data: { iframeUrl: any },
        private dialogRef: MatDialogRef<IframeModalComponent>
    ) {}

    closeModal(): void {
        this.dialogRef.close();
    }
}
